// ----------------------- REDUX CONSTANTS -----------------

export const CHALLENGE_PREFIX = 'challenge/';

const LOCAL_PREFIX = `local/${CHALLENGE_PREFIX}`;

export const SET_SELECTED_CHALLENGE = `${CHALLENGE_PREFIX}SET_SELECTED_CHALLENGE`;

export const SET_SELECTED_CHALLENGE_ID = `${CHALLENGE_PREFIX}SET_SELECTED_CHALLENGE_ID`;

export const SET_SELECTED_SEGMENT = `${CHALLENGE_PREFIX}SET_SELECTED_SEGMENT`;

export const TOP_CONTRIBUTORS_REQUESTED = `${CHALLENGE_PREFIX}TOP_CONTRIBUTORS_REQUESTED`;

export const TOP_CONTRIBUTORS_SUCCEEDED = `${CHALLENGE_PREFIX}TOP_CONTRIBUTORS_SUCCEEDED`;

export const TOP_CONTRIBUTORS_FAILED = `${CHALLENGE_PREFIX}TOP_CONTRIBUTORS_FAILED`;

export const CHANGE_TEAM_MODE = `${LOCAL_PREFIX}/CHANGE_TEAM_MODE`;

export const TOP_TAGS_REQUESTED = `${CHALLENGE_PREFIX}TOP_TAGS_REQUESTED`;

export const TOP_TAGS_SUCCEEDED = `${CHALLENGE_PREFIX}TOP_TAGS_SUCCEEDED`;

export const TOP_TAGS_FAILED = `${CHALLENGE_PREFIX}TOP_TAGS_FAILED`;

export const SEGMENTS_LIST_REQUESTED = `${CHALLENGE_PREFIX}SEGMENTS_LIST_REQUESTED`;

export const SEGMENTS_LIST_SUCCEEDED = `${CHALLENGE_PREFIX}SEGMENTS_LIST_SUCCEEDED`;

export const SEGMENTS_LIST_FAILED = `${CHALLENGE_PREFIX}SEGMENTS_LIST_FAILED`;

export const SEGMENT_TAGS_REQUESTED = `${CHALLENGE_PREFIX}SEGMENT_TAGS_REQUESTED`;

export const SEGMENT_TAGS_SUCCEEDED = `${CHALLENGE_PREFIX}SEGMENT_TAGS_SUCCEEDED`;

export const SEGMENT_TAGS_FAILED = `${CHALLENGE_PREFIX}SEGMENT_TAGS_FAILED`;

// Impact card actions
export const IMPACT_FILTER_REQUESTED = `${CHALLENGE_PREFIX}IMPACT_FILTER_REQUESTED`;

export const IMPACT_FILTER_SUCCEEDED = `${CHALLENGE_PREFIX}IMPACT_FILTER_SUCCEEDED`;

export const IMPACT_FILTER_FAILED = `${CHALLENGE_PREFIX}IMPACT_FILTER_FAILED`;

export const SPECIFIC_CHALLENGE_REQUESTED = `${CHALLENGE_PREFIX}SPECIFIC_CHALLENGE_REQUESTED`;

export const SPECIFIC_CHALLENGE_SUCCEEDED = `${CHALLENGE_PREFIX}SPECIFIC_CHALLENGE_SUCCEEDED`;

export const SPECIFIC_CHALLENGE_FAILED = `${CHALLENGE_PREFIX}SPECIFIC_CHALLENGE_FAILED`;

export const CONNECTED_CHALLENGE_REQUESTED = `${CHALLENGE_PREFIX}CONNECTED_CHALLENGE_REQUESTED`;

export const CONNECTED_CHALLENGE_SUCCEEDED = `${CHALLENGE_PREFIX}CONNECTED_CHALLENGE_SUCCEEDED`;

export const CONNECTED_CHALLENGE_FAILED = `${CHALLENGE_PREFIX}CONNECTED_CHALLENGE_FAILED`;

export const CHALLENGE_CODES_REQUESTED = `${CHALLENGE_PREFIX}CHALLENGE_CODES_REQUESTED`;

export const CHALLENGE_CODES_SUCCEEDED = `${CHALLENGE_PREFIX}CHALLENGE_CODES_SUCCEEDED`;

export const CHALLENGE_CODES_FAILED = `${CHALLENGE_PREFIX}CHALLENGE_CODES_FAILED`;

export const SET_PARENT_CHALLENGE = `${CHALLENGE_PREFIX}SET_PARENT_CHALLENGE`;

export const CHALLENGE_NOTIFICATIONS_REQUESTED = `${CHALLENGE_PREFIX}CHALLENGE_NOTIFICATIONS_REQUESTED`;

export const CHALLENGE_NOTIFICATIONS_SUCCEEDED = `${CHALLENGE_PREFIX}CHALLENGE_NOTIFICATIONS_SUCCEEDED`;

export const CHALLENGE_NOTIFICATIONS_FAILED = `${CHALLENGE_PREFIX}CHALLENGE_NOTIFICATIONS_FAILED`;

export const ADD_CHALLENGE_NOTIFICATION_REQUESTED = `${CHALLENGE_PREFIX}ADD_CHALLENGE_NOTIFICATION_REQUESTED`;

export const ADD_CHALLENGE_NOTIFICATION_SUCCEEDED = `${CHALLENGE_PREFIX}ADD_CHALLENGE_NOTIFICATION_SUCCEEDED`;

export const ADD_CHALLENGE_NOTIFICATION_FAILED = `${CHALLENGE_PREFIX}ADD_CHALLENGE_NOTIFICATION_FAILED`;

export const CHALLENGE_NOTIFICATION_RESET = `${CHALLENGE_PREFIX}CHALLENGE_NOTIFICATION_RESET`;

export const ADD_CHALLENGE_CODE_REQUESTED = `${CHALLENGE_PREFIX}ADD_CHALLENGE_CODE_REQUESTED`;

export const ADD_CHALLENGE_CODE_SUCCEEDED = `${CHALLENGE_PREFIX}ADD_CHALLENGE_CODE_SUCCEEDED`;

export const ADD_CHALLENGE_CODE_FAILED = `${CHALLENGE_PREFIX}ADD_CHALLENGE_CODE_FAILED`;

export const UPDATE_CHALLENGE_CODE_REQUESTED = `${CHALLENGE_PREFIX}UPDATE_CHALLENGE_CODE_REQUESTED`;

export const UPDATE_CHALLENGE_CODE_SUCCEEDED = `${CHALLENGE_PREFIX}UPDATE_CHALLENGE_CODE_SUCCEEDED`;

export const UPDATE_CHALLENGE_CODE_FAILED = `${CHALLENGE_PREFIX}UPDATE_CHALLENGE_CODE_FAILED`;

export const CLEAR_CHALLENGE_CODE_ERROR = `${CHALLENGE_PREFIX}CLEAR_CHALLENGE_CODE_ERROR`;
// ------------------- ETC Constants ----------------
export const NOTIFICATION_LIMIT = 50;
